import { urls } from "app/api/urls";
import { SessionHelper } from "../helpers/sessionHelper";
const API_EVENTS = `${urls.data.API_MOBILE_EVENTS()}`;
const API_EVENTS__ASIAN = `${urls.data.API_ASIAN_EVENTS()}`;
export class EventsAPIHelper {
  static getEventDesktopUrl(eventId: number): string {
    return SessionHelper.isAsianRouteAndSessionView()
      ? API_EVENTS__ASIAN + "/" + eventId
      : API_EVENTS + "/" + eventId;
  }

  static getEventDesktopLine(line?: string, params: any): any {
    // this function may not be neccessary but will leave in for the moment
    if (SessionHelper.isAsianRouteAndSessionView() && line) params.line = line;
    return params;
  }
}
